import { useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useCountry } from "../context/CountryContext";
import Landing from "../pages/Landing";

/**
 * CountryRoute — wrapper qui force une juridiction selon l'URL (/be, /fr, /lu, /ch).
 *
 * Exemples :
 *  - /fr → Landing en mode France 🇫🇷
 *  - /be → Landing en mode Belgique 🇧🇪
 *  - /lu → Landing en mode Luxembourg 🇱🇺 (Bêta)
 *  - /ch → Landing en mode Suisse romande 🇨🇭 (Bêta)
 *
 * Idéal pour partager des liens directs : "avocatdepoche.app/fr".
 * Le visiteur peut toujours changer ensuite avec le sélecteur.
 */

// Mappe URL slug → country id interne
const URL_TO_COUNTRY = {
  be: "be",
  fr: "fr",
  lu: "lu",
  ch: "ch-fr",
};

export default function CountryRoute() {
  const location = useLocation();
  const { setCountry, countryId, countries } = useCountry();

  // Extrait le premier segment du path : "/fr" → "fr"
  const slug = location.pathname.split("/").filter(Boolean)[0]?.toLowerCase();
  const targetCountry = URL_TO_COUNTRY[slug];

  useEffect(() => {
    // Attendre que la liste des pays soit chargée pour éviter d'écraser l'init
    if (!targetCountry || !countries.length) return;
    if (countryId !== targetCountry) {
      setCountry(targetCountry);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetCountry, countries.length]);

  // Slug inconnu → redirection vers la page d'accueil sans préfixe pays
  if (!targetCountry) {
    return <Navigate to="/" replace />;
  }

  return <Landing />;
}
